import React from 'react';

export type ChatReadyState = 'loading' | 'animating' | 'ready';

export function useVBAUIState(
  showProgressBar: boolean,
  progressDataLoaded: boolean
) {
  const [showVoice, setShowVoice] = React.useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
  const [hasInitialized, setHasInitialized] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => setHasInitialized(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const [chatReadyState, setChatReadyState] =
    React.useState<ChatReadyState>('loading');
  const hasProgressBarAnimated = React.useRef(false);

  React.useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = showVoice
      ? 'hidden'
      : originalOverflow || '';
    return () => {
      document.body.style.overflow = originalOverflow || '';
    };
  }, [showVoice]);

  const handleProgressBarAnimationComplete = React.useCallback(() => {
    if (hasProgressBarAnimated.current) return;
    hasProgressBarAnimated.current = true;
    setChatReadyState('ready');
  }, []);

  React.useEffect(() => {
    if (!hasInitialized) return;
    if (!progressDataLoaded) return;
    if (hasProgressBarAnimated.current) {
      setChatReadyState('ready');
    } else if (showProgressBar) {
      setChatReadyState('loading');
    } else {
      setChatReadyState('ready');
    }
  }, [showProgressBar, hasInitialized, progressDataLoaded]);

  return {
    showVoice,
    setShowVoice,
    isSidebarOpen,
    setIsSidebarOpen,
    chatReadyState,
    handleProgressBarAnimationComplete,
    hasProgressBarAnimated,
  };
}
